import { AxiosRequestConfig } from 'axios';
import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { auth } from 'utils/auth';
import request from 'utils/request';
import { layoutActions as actions } from '.';
import { Profile } from './types';

function* fetchProfileInfo() {
  const url = `v1/corporateUser/profile/me`;
  const options: AxiosRequestConfig = {
    method: 'GET',
  };
  try {
    const response: Profile = yield call(request, url, options);
    yield put(actions.setProfile(response));
  } catch (ex: any) {
    yield put(actions.setError(ex.data));
    console.log(ex.data);
  }
}

function* refreshToken() {
  yield delay(500);
  let url = `v1/oauth/token`;
  const refreshToken = auth.getRefreshToken();
  // @ts-ignore
  const corporateId = auth.getUserData()?.corporateId;
  const options: AxiosRequestConfig = {
    method: 'POST',
    params: {
      grant_type: 'refresh_token',
      refresh_token: refreshToken,
      corporateId: corporateId,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Basic QkRBTUp3dENsaWVudDEwMElkOlhZVmtOelJOekExT08wQkRBTQ',
    },
  };
  try {
    const response = yield call(request, url, options);
    auth.logout();
    auth.setToken(response.access_token, true);
    auth.setRefreshToken(response.refresh_token);
  } catch (ex) {
    console.log(ex);
    auth.logout();
  }
}

export function* layoutSaga() {
  yield takeLatest(actions.getProfileInfo, fetchProfileInfo);
  yield takeLatest(actions.refreshToken, refreshToken);
}
